/* eslint-disable react/prop-types */
import React, { useCallback, useRef, useEffect, useState } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CellValueChangedEvent, ColumnApi, GridReadyEvent, GridApi } from "ag-grid-community";
import { CoveredDependentsProps } from "../../../../@types/components/enrollmentProps.types";
import { Checkbox } from "@material-ui/core";
import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";

import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import "./coveredDependents.css";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Member } from "../../../../@types/member.types";

const CoveredDependents = ({ dependents, handleSelectDependent }: CoveredDependentsProps): JSX.Element => {
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef<any>(null);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const { theme } = useContext(ThemeContext);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		api.sizeColumnsToFit();
	};

	const _handleSelectDependent = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let member: Member;
			if (dependents.length === 1) {
				member = dependents[0];
			} else {
				const focusedCell = agGridRef.current.api.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell?.rowIndex);
				member = row?.data;
			}
			handleSelectDependent(event, member);
		},
		[dependents, handleSelectDependent]
	);

	const selectDependentCellRenderer = useCallback(
		({ value }: { value: boolean }) => {
			return <Checkbox onChange={_handleSelectDependent} checked={value} />;
		},
		[_handleSelectDependent]
	);

	useEffect(() => {
		switch (dependents.length) {
			case 0: {
				setGridHeight("110px");
				break;
			}
			case 1: {
				setGridHeight("110px");
				break;
			}
			case 2: {
				setGridHeight("160px");
				break;
			}
			case 3: {
				setGridHeight("200px");
				break;
			}
			case 4: {
				setGridHeight("240px");
				break;
			}
			case 5: {
				setGridHeight("290px");
				break;
			}
			case 6: {
				setGridHeight("340px");
				break;
			}
			case 7: {
				setGridHeight("390px");
				break;
			}
		}
	}, [dependents.length]);

	console.log("dependents", dependents);

	return (
		<div className="covered-dependents">
			<div className="header-container">
				<div className="theme-plan-header">Covered Dependents</div>
				<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
					In addition to yourself, who would you like to cover under this plan?
				</div>
			</div>
			<div className="theme-plan-inner-section-margin" />
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				{dependents.length !== 0 ? (
					<AgGridReact
						ref={agGridRef}
						rowData={dependents}
						onGridReady={handleAgGridReady}
						animateRows
						rowDragManaged
						defaultColGroupDef={{ marryChildren: true }}
						enableCellChangeFlash={true}
						frameworkComponents={{
							selectDependentCellRenderer
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["select_dependent"]
							});
						}}
					>
						<AgGridColumn field="first_name" headerName="First Name"></AgGridColumn>
						<AgGridColumn field="last_name" headerName="Last Name"></AgGridColumn>
						<AgGridColumn field="relationship" headerName="Relationship"></AgGridColumn>
						<AgGridColumn
							headerName="Select Dependent"
							cellRenderer="selectDependentCellRenderer"
							field="covered"
						></AgGridColumn>
					</AgGridReact>
				) : null}
			</div>
			<div className="theme-plan-inner-section-margin" />
		</div>
	);
};

export default CoveredDependents;
